import type { QueueOptions } from './types.js';

// This should really just be <T>, but I think that would be a breaking change
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default <T = any>(
  options: QueueOptions = {},
): {
  size: () => number;
  enqueue: (item: T) => void;
  dequeueAll: (fn: (item: T) => void) => void;
} => {
  const { max = 200 } = options;
  const queue: T[] = [];

  const size = () => queue.length;

  const enqueue = (item: T) => {
    if (size() < max) {
      queue.push(item);
    }
  };

  const dequeue = () => queue.shift();

  const dequeueAll = (fn: (item: T) => void) => {
    while (size() > 0) {
      // T can not be undefined as dequeue will always return a value since
      // we are checking the size of the queue before calling it
      fn(dequeue() as T);
    }
  };

  return {
    size,
    enqueue,
    dequeueAll,
  };
};
